var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2617 4.99923H14.5951M14.5951 4.99923H1.26172M14.5951 4.99923V16.6659C14.5951 17.1079 14.4195 17.5318 14.1069 17.8444C13.7943 18.157 13.3704 18.3326 12.9284 18.3326H4.59505C4.15302 18.3326 3.7291 18.157 3.41654 17.8444C3.10398 17.5318 2.92839 17.1079 2.92839 16.6659V4.99923H14.5951ZM12.0951 4.99923V3.33256C12.0951 2.89053 11.9195 2.46661 11.6069 2.15405C11.2943 1.84149 10.8704 1.66589 10.4284 1.66589H7.09505C6.65302 1.66589 6.2291 1.84149 5.91654 2.15405C5.60398 2.46661 5.42839 2.89053 5.42839 3.33256V4.99923M10.4284 9.16589V14.1659M7.09505 9.16589V14.1659",
    stroke: "#262626",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.6b47ce0458df0ccf9bea6b0be81327b5.svg";
export { ForwardRef as ReactComponent };